exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Logo__root___1RJ-1 {\n  display: inline-block\n}\n.Logo__root___1RJ-1 svg {\n    width: 100%;\n    height: 100%;\n  }", ""]);

// exports
exports.locals = {
	"root": "Logo__root___1RJ-1"
};